module.exports = __webpack_public_path__ + "assets/images/popups/intro_start_ru.png";